export var CRUDOperation;
(function (CRUDOperation) {
    CRUDOperation["Get"] = "fetching";
    CRUDOperation["Update"] = "updating";
    CRUDOperation["Delete"] = "deleting";
    CRUDOperation["Add"] = "adding";
    CRUDOperation["Selecting"] = "selecting";
    CRUDOperation["Saving"] = "saving";
    CRUDOperation["Running"] = "running";
})(CRUDOperation || (CRUDOperation = {}));
